import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { Workstep } from '../../_models/workstep';

import { MessageService } from '../../_services/message.service';
import { Globals } from '../../_globals/globals';

@Injectable({
  providedIn: 'root'
})

export class WorkstepService {
  constructor(
    private http: HttpClient,
    private globals: Globals,
    private messageService: MessageService
  ) { }

  // loadWorkstepsOnLogin(): Observable<Workstep[]> {
  //   console.log('**** Running ordersPlanned loadWorkstepsOnLogin service');

  //   return this.http.get<Workstep[]>(this.globals.apiUrl + '/wss_lfs', {}).pipe(
  //     tap(() => console.log('**** Worksteps obtained from loadWorkstepsOnLogin')), // + JSON.stringify(data))),
  //     catchError(this.handleError<Workstep[]>('loadWorkstepsOnLogin', []))
  //   );
  // }

  // loadWorkstepsOnReload(): Observable<Workstep[]> {
  //   console.log('**** Running ordersPlanned loadWorkstepsOnReload service');

  //   return this.http.get<Workstep[]>(this.globals.apiUrl + '/wss_lfs', {}).pipe(
  //     tap(() => console.log('**** Worksteps obtained from loadWorkstepsOnReload')), // + JSON.stringify(data))),
  //     catchError(this.handleError<Workstep[]>('loadWorkstepsOnReload', []))
  //   );
  // }

  // -------------------

  loadWorksteps(searchParams): Observable<Workstep[]> {
    console.log('**** Running loadWorksteps service');
    // console.log(searchParams);

    let params = new HttpParams();

    if (searchParams !== null && searchParams !== undefined) {
      for (const key in searchParams) {
        if (searchParams.hasOwnProperty(key)) {
          // SI NO PASAMOS OBJETOS
          params = params.set(key, searchParams[key]);
          // SI PASAMOS OBJETOS: JSON.stringify() Y JSON.parse()
          // params = params.set(key, JSON.stringify(searchParams[key]));
        }
      }
    }

    const options = { params: params };

    return this.http.get<Workstep[]>(this.globals.apiUrl + '/workstep', options).pipe(
      tap(data => console.log('**** Worksteps obtained from loadWorksteps')), // + JSON.stringify(data))),
      catchError(this.handleError<Workstep[]>('loadWorksteps', []))
    );
  }

  createWorkstep(workstep: Workstep): Observable<Workstep> {
    console.log('**** Running createWorkstep service');
    // console.log(workstep);

    return this.http.post<Workstep>(this.globals.apiUrl + '/workstep', workstep, {}).pipe(
      tap(  _ => this.log('Workstep created from createWorkstep')),
      catchError(this.handleError<Workstep>('createWorkstep', null))
    );
  }

  updateWorkstep(params: any): Observable<Workstep> {
    console.log('**** Running updateWorkstep service');
    // console.log(workstepIn);

    return this.http.put<Workstep>(this.globals.apiUrl + '/workstep', params, {}).pipe(
      tap(  _ => this.log('Workstep updated from updateWorkstep')),
      catchError(this.handleError<Workstep>('updateWorkstep', null))
    );
  }

  deleteWorkstep(workstep: Workstep): Observable<bigint> {
    console.log('**** Running deleteWorkstep service');
    // console.log(workstep);

    let options = { params: new HttpParams().set('id', workstep['id'].toString()) };

    return this.http.delete<bigint>(this.globals.apiUrl + '/workstep', options).pipe(
      tap(  _ => this.log('Workstep deleted from deleteWorkstep')),
      catchError(this.handleError<bigint>('deleteWorkstep', null))
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  getAllWorksteps(): Observable<Workstep[]> {
    console.log('**** Running getAllWorksteps service');

    return this.http.get<Workstep[]>(this.globals.apiUrl + '/getAllWorksteps').pipe(
      tap( data => console.log(' -> Proyectos obtenidos desde getAllWorksteps: ' + JSON.stringify(data))),
      catchError(this.handleError<Workstep[]>('getAllWorksteps', []))
    );
  }

  getWorkstep(searchParams): Observable<Workstep> {
    console.log('**** Running getWorkstep service');
    // console.log(searchParams);

    const options = { params: new HttpParams().set('id', searchParams.id) };

    return this.http.get<Workstep>(this.globals.apiUrl + '/workstep', options).pipe(
      tap(  _ => this.log('get workstep')),
      catchError(this.handleError<Workstep>('getWorkstep', null))
    );
  }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error (error); // lot to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // TODO: Let the app keep running by returning an empty result.
      return of (result as T);
    };
  }

}
